module.exports = __webpack_public_path__ + "images/1-h66983fd843586a925e8d787e04766afd.svg";